module.exports = __webpack_public_path__ + "img/@contact_bottom.74fcfd6e.jpg";